/*********************** Custom JS for Boost AI Search & Discovery  ************************/
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        /* Start-Boost-229842 */
        componentRegistry.useComponentPlugin('FormatCurrency', {
            name: 'Show Trailing Zeros',
            apply: () => ({
                afterRender: (element) => {
                    try {
                        // Start customization--------------------------------------------
                        const formatMoneyHelper = element.getHelpers().formatMoney;
                        if (!formatMoneyHelper) return;
                        const value = element.getParams().props.value; // Get price
                        const customValue = formatMoneyHelper(Number(value), window.boostSDAppConfig?.shop?.money_format, true);

                        if (customValue && element.getRootElm() && element.getRootElm().querySelector('.boost-sd__format-currency span')) {
                            element.getRootElm().querySelector('.boost-sd__format-currency span').innerHTML = customValue;
                        }
                        // End-------------------------------------------------------------
                    } catch (e) {
                        console.warn(e);
                    }
                },
            }),
        });
        /* End-Boost-229842 */
    }
]);